module.exports = __webpack_public_path__ + "img/yinhanga.8a89eb34.png";